import { render, staticRenderFns } from "./Customer-Tasks-Report.vue?vue&type=template&id=4c59da08&"
import script from "./Customer-Tasks-Report.vue?vue&type=script&lang=js&"
export * from "./Customer-Tasks-Report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports